'use client';

import Section from '@framework/ui/Pages/Landing/Sections/Section';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import TabsSlider from '@framework/ui/Pages/Landing/Sections/TabsSlider';
import { marketingProcessTab } from './tabs';

const IntegratedProcess = () => (
  <Section padding="top" id="integrations">
    <SectionContainer>
      <SectionHeader
        title="Deeply integrated into your new issue marketing process."
        description="Allocate is fully integrated into the FINSIGHT ecosystem, offering broker-dealers and issuers comprehensive coverage of investor engagement from the Deal Roadshow, through the global investor call, to the final outcome."
        maxWidth={ 942 }
      />
    </SectionContainer>
    <SectionContainer size="large" narrow>
      <TabsSlider
        content={ marketingProcessTab }
      />
    </SectionContainer>
  </Section>
);

export default IntegratedProcess;
